const THREE = (window.THREE = require('three'));

const rotationSpeed = 0.000375; //0.00075;

class PlanetScene extends THREE.Scene {
  planet = null;
  clouds = null;

  constructor(texture) {
    super();

    this.update = this.update.bind(this);

    this.initPlanet(texture);
  }

  initPlanet = map => {
    const planetWireMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      polygonOffset: true,
      polygonOffsetFactor: 1,
      polygonOffsetUnits: 1,
    });

    map.wrapS = THREE.RepeatWrapping;
    map.repeat.set(2, 1);

    const planetGeometry = new THREE.SphereBufferGeometry(6371, 36, 18);
    const planetMaterial = new THREE.MeshLambertMaterial({
      depthWrite: false,
      map,
    });

    const planet = new THREE.Mesh(planetGeometry, planetMaterial);
    planet.position.x = 20000;
    planet.position.y = 9000;
    planet.position.z = -150000;

    const planetWire = new THREE.Mesh(planetGeometry, planetWireMaterial);
    const wireGeometry = new THREE.EdgesGeometry(planetGeometry);
    const wireMaterial = new THREE.LineBasicMaterial({
      color: 0xf1f1f1,
      linewidth: 2,
      lights: false,
    });
    const wireMesh = new THREE.LineSegments(wireGeometry, wireMaterial);
    planetWire.add(wireMesh);
    wireMesh.layers.set(100);
    planetWire.layers.set(100);

    this.planet = planet;
    this.planetWire = planetWire;
    this.add(planet);
    planet.add(planetWire);
  };

  update(deltaMultiplier) {
    this.planet.rotation.y -= rotationSpeed * deltaMultiplier;
    //this.planetWire.rotation.y -= 0.00075 * deltaMultiplier;
  }
}

export default PlanetScene;



// WEBPACK FOOTER //
// ./src/modules/parallax/webgl/PlanetScene.js